<template>
  <div>
    <div class=" px-12 py-8 max-w-5xl mx-auto">
      <div class=" text-center text-2xl mb-4">{{ $t('account.add_beneficiary') }}</div>
      <a-steps :current="current">
      <a-step v-for="item in steps" :key="item.title" :title="item.title" />
    </a-steps>
    </div>
    <div class="px-12 max-w-2xl mx-auto bg-white">
      <router-view @update:current="handleCurrentUpdate"></router-view>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n'

export default {
  created () {
    console.log(this.$route.fullPath)
  },
  data () {
    return {
      current: 0,
      steps: [
        {
          get title () { return i18n.t('account.beneficiary_information') }
        },
        {
          get title () { return i18n.t('account.bank_account_details') }
        },
        {
          get title () { return i18n.t('account.review') }
        },
        {
          get title () { return i18n.t('account.done') }
        }
      ]
    }
  },
  methods: {
    handleCurrentUpdate (value) {
      this.current = value
    }
  }
}
</script>

<style scoped>

</style>
